"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonFooter = _interopRequireDefault(require("../ButtonFooter"));
var _Container = _interopRequireDefault(require("../Container"));
var _ExpandButton = _interopRequireDefault(require("../ExpandButton"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Hooks = require("../Hooks");
var _reactI18next = require("react-i18next");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ImagePreview = _ref => {
  let {
    active,
    alt,
    caption,
    expandImage = true,
    onToggle,
    url,
    width = '100%'
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [fullSizeImage, toggleFullSizeImage] = (0, _Hooks.useToggle)(false);
  const imageProps = {
    fullSizeImage
  };
  const modalProps = {
    active,
    height: fullSizeImage ? '100%' : 'auto',
    onToggle,
    padding: '5px',
    width
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, _objectSpread(_objectSpread({}, modalProps), {}, {
    children: [expandImage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container.default, {
      alignItems: "flex-end",
      width: "100%",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        icon: "open_in_full",
        fontSize: "14px",
        onClick: toggleFullSizeImage,
        size: 14
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ImageContainer, _objectSpread(_objectSpread({}, imageProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Image, {
        alt: alt !== null && alt !== void 0 ? alt : t('Previsualización'),
        loading: "lazy",
        src: url
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonFooter.default, {
      margin: "10px 0px 0px 0px",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandButton.default, {
        caption: caption !== null && caption !== void 0 ? caption : t('Cerrar'),
        size: 100,
        onClick: onToggle
      })
    })]
  }));
};
ImagePreview.propTypes = {
  active: _propTypes.default.bool,
  alt: _propTypes.default.string,
  caption: _propTypes.default.string,
  expandImage: _propTypes.default.bool,
  url: _propTypes.default.string,
  onToggle: _propTypes.default.func,
  width: _propTypes.default.string
};
var _default = exports.default = ImagePreview;